import { useState, useEffect } from 'react';
import { assessmentProgressApi } from '../services/api';

interface ExternalAssessmentProgress {
  pestel: number;
  fiveForces: number;
  competitors: number;
  drivingForces: number;
  overall: number;
}

export function useExternalAssessmentProgress(companyId: string) {
  const [progress, setProgress] = useState<ExternalAssessmentProgress>({
    pestel: 0,
    fiveForces: 0,
    competitors: 0,
    drivingForces: 0,
    overall: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  // Function to refresh progress
  const refreshProgress = async () => {
    if (!companyId) return;

    setIsLoading(true);
    try {
      const response = await assessmentProgressApi.getExternalProgress(companyId);

      if (response.success && response.data) {
        const newProgress = {
          pestel: response.data.sections.pestel,
          fiveForces: response.data.sections.fiveForces,
          competitors: response.data.sections.competitors,
          drivingForces: response.data.sections.drivingForces,
          overall: response.data.overall,
        };

        setProgress(newProgress);
      } else {
        console.error('External Assessment API call failed:', response.error);
      }
    } catch (error) {
      console.error('Failed to calculate external assessment progress:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Load progress on mount and when companyId changes
  useEffect(() => {
    if (companyId) {
      refreshProgress();
    }
  }, [companyId]);

  return {
    progress,
    isLoading,
    refreshProgress,
  };
}
